module.exports = __webpack_public_path__ + "img/two1Blue.8f547312.jpg";